export enum AttachmentModalSteps {
  Select = 'select',
  Preview = 'preview',
}
